import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const AdminRoleUrl = `${Base_Url}/AdminRole`;

export const GetAdminRoleList = async (params) => {
  const res = await postApiWithAuthorization(
    `${AdminRoleUrl}/GetAdminRoleList`,
    params
  );
  return res;
};

export const AddUpdateAdminRole = async (params) => {
  const res = await postApiWithAuthorization(
    `${AdminRoleUrl}/AddUpdateAdminRole?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetAdminRoleModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${AdminRoleUrl}/GetAdminRoleModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&AdminRoleKeyID=${KeyID}`
  );
  return res;
};

export const ChangeAdminRoleStatus = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${AdminRoleUrl}/ChangeAdminRoleStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&AdminRoleKeyID=${KeyID}`
  );
  return res;
};

export const DeleteAdminRole = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${AdminRoleUrl}/DeleteAdminRole?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&AdminRoleKeyID=${KeyID}`
  );
  return res;
};

export const GetAdminRoleLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${AdminRoleUrl}/GetAdminRoleLookupList`
  );
  return res;
};
